var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer-box"},[_c('h3',[_vm._v("Support AI")]),_c('div',{staticClass:"inner-box",staticStyle:{"text-align":"left","max-height":"99vh !important","height":"80vh"}},[_c('SupportChatComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }